import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import getBaseUrl from 'libs/baseUrl';

const responsive = {
  largeDesktop: {
    breakpoint: { max: 3000, min: 1200 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 1199, min: 992 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 991, min: 768 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 767, min: 0 },
    items: 1,
  },
};

const SlideItem = ({ item }) => {
  const baseUrl = getBaseUrl();
  const handleClick = () => {
    if (item?.redirectionLink) {
      window.open(item.redirectionLink, '_blank');
    }
  };

  const extractBaseUrlWithoutPath = url => {
    try {
      const { protocol, host } = new URL(url);
      return `${protocol}//${host}`;
    } catch (error) {
      console.error('Invalid URL:', url);
      return null;
    }
  };

  const url = extractBaseUrlWithoutPath(baseUrl);

  return (
    <div
      className='max-h-[500px] cursor-pointer rounded-lg text-center'
      onClick={handleClick}
    >
      <img
        src={`${url}${item.path}`}
        alt={item?.name}
        className='size-full rounded-[20px] object-cover'
      />
    </div>
  );
};

const SliderExample = ({ data }) => {
  return (
    <Carousel
      responsive={responsive}
      infinite
      autoPlay={true}
      containerClass='carousel-container'
      itemClass='carousel-item-padding-40-px'
    >
      {data?.map(item => (
        <SlideItem key={item.linkedUrl + item?.name} item={item} />
      ))}
    </Carousel>
  );
};

export default SliderExample;
